import { ApiResponse } from "interface/response"
import { AxiosApi } from "./index";
import { Product } from "interface/common";
import { IProduct } from "interface/product";


export async function SearchProfileAllProducts(text: string) {
    const apiUri = "Product/SearchProfileAllProducts";

    try {
        const products = await AxiosApi.get<ApiResponse<Product[]>>(apiUri, {
            params: { text }
        })
        return products.data.data
    } catch (error: any) {
         
          throw  error
       }
}


export async function getProductsByBuyerApi() {
    const apiUri = "Product/ProductsByBuyer"

    try {
        const products = await AxiosApi.get<ApiResponse<Product[]>>(apiUri)

        return products.data
    } catch (error) {
        throw error
    }
}

export async function getProfileSmsProductsApi() {  
    const apiUri = "Product/ProfileSmsProducts"

    try {
        const products = await AxiosApi.get<ApiResponse<IProduct[]>>(apiUri)

        return products.data
    } catch (error) {
        throw error
    }
}

export async function addSmsProductFromProfileApi(specieCode:string, productId: string) {
    const apiUri = "Product/AddSmsProductFromProfile"

    try {
        const products = await AxiosApi.post<ApiResponse<any>>(apiUri, {specieCode , productId })

        return products.data
    } catch (error) {
        throw error
    }
}

export async function getSearchProfileSmsProductsApi(text: string, specieCode: string) {  
    const apiUri = "Product/SearchSmsProfileProducts"

    try {
        const products = await AxiosApi.get<ApiResponse<IProduct[]>>(apiUri, { params: { text, specieCode } })

        return products.data.data
    } catch (error) {
        throw error
    }
}

export async function deleteSmsProductFromProfileApi(id: string) {
    const apiUri = "Product/DeleteSmsProductFromProfile"

    try {
        const products = await AxiosApi.delete<ApiResponse<any>>(apiUri, { params: { id } })

        return products.data
    } catch (error) {
        throw error
    }
}

export async function addProductToProfileApi(productId: string) {
    const apiUri = "Product/AddProductToProfile"

    try {
        const products = await AxiosApi.post<ApiResponse<any>>(apiUri, { productId })

        return products.data
    } catch (error) {
        throw error
    }
}


export async function deleteProductFromProfileApi(productId: string) {
    const apiUri = "Product/DeleteProductFromProfile"

    try {
        const registrations = await AxiosApi.delete<ApiResponse<any>>(apiUri, { params: { productId } })

        return registrations.data
    } catch (error) {
        throw error
    }
}

